import React from 'react';
import { Link } from 'react-router-dom';

// A bold, linked company name inside running text
const Company = ({ href, children }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className="font-semibold text-ink hover:text-accent underline decoration-line hover:decoration-accent underline-offset-2 transition-colors"
  >
    {children}
  </a>
);

// A single row in the writing / links list
const Entry = ({ href, title, blurb, external }) => {
  const inner = (
    <>
      <span className="min-w-0">
        <span className="font-medium text-ink group-hover:text-accent transition-colors">
          {title}
        </span>
        {blurb && <span className="text-muted">  {blurb}</span>}
      </span>
      <span className="shrink-0 text-faint group-hover:text-accent transition-transform group-hover:translate-x-0.5">
        →
      </span>
    </>
  );

  const cls =
    'group flex items-baseline justify-between gap-3 py-2.5 border-b border-line last:border-b-0';

  return external ? (
    <a href={href} target="_blank" rel="noopener noreferrer" className={cls}>
      {inner}
    </a>
  ) : (
    <Link to={href} className={cls}>
      {inner}
    </Link>
  );
};

const Social = ({ href, label }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className="text-muted hover:text-accent transition-colors"
  >
    {label}
  </a>
);

const HomePage = () => {
  return (
    <div>
      {/* Intro */}
      <div className="flex items-center gap-4 mb-7">
        <img
          src="/images/profile.jpeg"
          alt="Giorgio Zinetti"
          className="w-16 h-16 rounded-full object-cover ring-1 ring-line"
        />
        <div>
          <h1 className="text-2xl font-bold tracking-tight mt-0 mb-1">Giorgio Zinetti</h1>
          <p className="text-muted mb-0">Site CTO, Switzerland · Wonderful</p>
        </div>
      </div>

      <p className="text-[17px] leading-8 text-muted">
        I'm Site CTO for Switzerland at{' '}
        <Company href="https://www.wonderful.ai/">Wonderful</Company> and an angel investor.
        I've spent ~15 years building systems people trust — from
        banking security at <Company href="https://www.ubs.com">UBS</Company> to digital
        identity at <Company href="https://www.procivis.ch">Procivis</Company> to
        blockchain at the{' '}
        <Company href="https://cardanofoundation.org">Cardano Foundation</Company>. I
        angel-invest in early-stage AI, blockchain, and longevity startups, and I think a
        lot about what AI agents will need to be trusted. I'm also co-founder &amp; board
        member of <Company href="https://www.saipient.ch/">Saipient</Company> (AI
        healthcare) and co-founder &amp; chairman of the board at{' '}
        <Company href="https://www.mito-bouldering.ch/">Mito</Company> (climbing gym).
      </p>

      {/* Work with me */}
      <section className="mt-12">
        <h2 className="text-sm font-semibold uppercase tracking-wider text-faint mt-0 mb-2">
          Work with me
        </h2>
        <div>
          <Entry
            href="/work-with-me"
            title="Investing & advisory"
            blurb="— how I can help founders"
          />
        </div>
      </section>

      {/* Elsewhere */}
      <section className="mt-12">
        <h2 className="text-sm font-semibold uppercase tracking-wider text-faint mt-0 mb-3">
          Elsewhere
        </h2>
        <div className="flex flex-wrap gap-x-5 gap-y-2 text-[15px]">
          <Social href="https://x.com/giozzi" label="X" />
          <Social href="https://www.linkedin.com/in/giorgio-zinetti-51423753" label="LinkedIn" />
          <Social href="https://www.instagram.com/giojzi/" label="Instagram" />
          <Social href="https://github.com/giojzi" label="GitHub" />
        </div>
      </section>
    </div>
  );
};

export default HomePage;
